import React from 'react'

export default () => <div style={{ padding: "20px", color: "red" }}>There is no data</div>
